import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TABLES } from '../../../../../Apis/Tables';
import { permissionObj } from '../../../../../Helpers/permission';
import { DeleteItemsApi } from '../../../../../reduxToolkit/Commons/CommonsApi';
import { GetQr } from '../../../../../reduxToolkit/FoodieExtraMeal/FoodieExtraMealApi';
import {
    SUB_VIEW_MODEL,
    TABS_FOODIE_ORDERS,
    TABS_FOODIE_ORDERS_CONTRACTOR_SUPPLIER
} from '../../../DiningOrders/Model/Models';

import QRCode from "qrcode";
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import { errorMsg } from '../../../../../Apis/functions';
import { useOrdersContextProvider } from '../../../DiningOrders/Functionality/OrdersContextProvider';
import {MODELS} from "../../../../../Apis/Models";

/**
 * @Author: Susana García Rodríguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 *
 */
const ExtraMealApp = ({ subView, setSubView, setOption, setModuleId }) => {
    const qrContainerRef = useRef(null);
    const navigate = useNavigate();
    const [steps, setSteps] = useState([]);
    const [showSupplierRequestModal, setShowSupplierRequestModal] = useState(false);
    const [itemSelected, setItemSelected] = useState(null);
    const [showSummaryModal, setShowSummaryModal] = useState(false);
    const [deleteMealRequestShow, setDeleteMealRequestShow] = useState(false);
    const [modified, setModified] = useState(false);
    // Redux state and utilities
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.authenticatioauthennSlice);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const { paramsContext, setParamsContext } = useOrdersContextProvider();
    const userTypeId = user?.data?.userType?.id;
    const userId = user?.data?.id;
    const location = useLocation();
    const contractorId = sessionStorage.getItem('contractorId');
    const supplierId = sessionStorage.getItem('providerId');
    const { tabIndex: navTabIndex, subView: navSubView } = location.state || {};
    const initialStep = navSubView && (contractorId || supplierId) ? TABS_FOODIE_ORDERS_CONTRACTOR_SUPPLIER.HISTORY.INDEX: TABS_FOODIE_ORDERS.ORDER.INDEX;
    const [activeStep, setActiveStep] = useState(initialStep);
    const [searchElement, setSearchElement] = useState('');

    useEffect(() => {
        if (typeof navSubView !== "undefined") {
            if (contractorId || supplierId) {
                setActiveStep(TABS_FOODIE_ORDERS_CONTRACTOR_SUPPLIER.HISTORY.INDEX);
            } else {
                changeSubView(navSubView);
            }
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [navTabIndex, navSubView, contractorId, supplierId]);


    /**
     * Effect: Sets the default subview to REQUEST_MEALS.ACTIVE if user has permission or is in DEV mode.
     */
    useEffect(() => {
        if ((DEV || permission?.includes(permissionObj?.WEB_FOODIE_EXTRA_REQUEST_VIEW)) && !subView && !navSubView) {
            changeSubView(SUB_VIEW_MODEL.REQUEST_MEALS.ACTIVE);
        }
    }, [paramsContext?.tabIndex, subView, permission, navSubView]);

    /**
     * Effect: Initialize steps for navigation (Active, History).
     */
    useEffect(() => {
        setSteps([t("active"), t("history")]);
    }, [t]);

    /**
     * Effect: Reset search results when subView changes for EMPLOYEE and Contractor and supplier type.
     */
    useEffect(() => {
        setSearchElement('');
    }, [subView, activeStep]);

    /**
     * Contractor/Supplier: Handle step change (Active <-> History):
     * - Reset search results and filters
     * - Update active step
     * - Change subview accordingly
     */
    const handleStepChange = (step) => {
        setActiveStep(step);
        if (step === TABS_FOODIE_ORDERS_CONTRACTOR_SUPPLIER.ACTIVE.INDEX) {
            handleShowActive();
        } else {
            handleShowHistory();
        }
    };

    /**
     * Show "Active Requests" subview for employees.
     */
    const handleShowActive = () => {
        changeSubView(SUB_VIEW_MODEL.REQUEST_MEALS.ACTIVE);
    };

    /**
     * Show "History" subview for employees.
     */
    const handleShowHistory = () => {
        changeSubView(SUB_VIEW_MODEL.REQUEST_MEALS.HISTORY);
    };

    const changeSubView = (subView) => {
        setSearchElement('');
        if(subView === SUB_VIEW_MODEL.REQUEST_MEALS.ACTIVE){
            if(setSubView) setSubView(SUB_VIEW_MODEL.REQUEST_MEALS.ACTIVE);
            setOption(null);
            setModuleId(null);
        }else if(subView === SUB_VIEW_MODEL.REQUEST_MEALS.HISTORY){
            if(setSubView) setSubView(SUB_VIEW_MODEL.REQUEST_MEALS.HISTORY);
            setOption(TABLES.EXTRA_REQUEST_HISTORY);
            setModuleId(MODELS.FOODIE_EXTRA_REQUEST)
        }
    }

    const handleDownload = async (id) => {
        const { payload } = await dispatch(GetQr(id));
        const { data: responseData, success } = payload.data;
        if (!success) return;
          const qrData = responseData ? JSON.stringify(responseData) : null;
        try {
            const image = await QRCode.toDataURL(String(qrData), { width: 300 });
            const link = document.createElement('a');
            link.href = image;
            link.download = t("qr_code") + '.png';
            link.click();
            setShowSummaryModal(false);
        } catch (err) {
            toast.error(t('something_went_wrong_2 '));
        }
    };

    /**
     * Delete the selected meal request.
     */
    const deleteSelectedMealRequest = async (deleteItem) => {
        const body = [deleteItem];
        const tableName = TABLES.FOODIE_USER_MENU;

        dispatch(DeleteItemsApi({ tableName, body })).then(({ payload }) => {
            const success = payload?.data?.success;
            const code = payload?.data?.code;
            if (success) {
                setDeleteMealRequestShow(false);
                setModified(true);
            } else {
                errorMsg(code);
            }
        });
    };


    return {
        DEV,
        permission,
        t,
        steps,
        activeStep,
        setActiveStep,
        deleteMealRequestShow,
        setDeleteMealRequestShow,
        showSummaryModal,
        setShowSummaryModal,
        userTypeId,
        itemSelected,
        setItemSelected,
        modified,
        setModified,
        qrContainerRef,
        showSupplierRequestModal,
        setShowSupplierRequestModal,
        searchElement,
        setSearchElement,
        handleStepChange,
        deleteSelectedMealRequest,
        handleShowActive,
        handleShowHistory,
        handleDownload,
        userId
    };
};

export default ExtraMealApp;
